export default __webpack_public_path__ + "static/media/big-logo.759538fe.svg";